export default __webpack_public_path__ + "static/media/circle-info-text.e6b8a4fe.png";